"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readsConfig = exports.ausReadsConfig = exports.ukReadsConfig = void 0;
var core_1 = require("../../../shared/core");
exports.ukReadsConfig = {
    softForceDisabled: false,
    showNonCommPrompt: true,
    removeBackDated: false,
    clientThresholdChecks: false,
    industryReadsRequired: false,
    prioritiseIndustryEstimates: false,
    openingReadsFlow: true,
};
exports.ausReadsConfig = {
    softForceDisabled: true,
    showNonCommPrompt: false,
    removeBackDated: true,
    clientThresholdChecks: true,
    industryReadsRequired: true,
    prioritiseIndustryEstimates: true,
    openingReadsFlow: false,
};
var readsConfig = function (option) {
    var retailer = core_1.configService.getConfig().retailer;
    switch (retailer.region) {
        case 'AUS':
            return exports.ausReadsConfig[option];
        case 'UK':
            return exports.ukReadsConfig[option];
    }
};
exports.readsConfig = readsConfig;
